import React from 'react';
import classnames from 'classnames';
import Legend from './component/Legend';
import Map from './component/Map';
import DrupalHelper from './helper/DrupalHelper';
import { AppContext } from './context/AppContext';
import './scss/App.scss';

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      legends: DrupalHelper.getLegend(),
      legend_field: DrupalHelper.getLegendField(),
      legend: 'all',
      setLegend: (value) => {
        this.setState({legend: value});
      }
    }
  }

  render() {
    return (
      <AppContext.Provider value={this.state}>
        <div className={classnames('fellow_map', 'fellow_google_map')}>
          <Legend/>
          <Map/>
        </div>
      </AppContext.Provider>
    );
  }
}

export default App;
